import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import { Offline, Detector } from 'react-detect-offline'
import { renderField } from '../../components/utils/input'
import { SecureStorage } from '../../utils'
import Config from '../../config'
import './styles.scss'
import validate from './validate'
import ErrorModal from '../Modals/error'

class Login extends Component {
  constructor() {
    super()
    this.state = {
      showError: false
    }
    this.onSubmit = this.onSubmit.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  componentWillMount() {
    if (localStorage.getItem('Authorization')) {
      this.props.history.push('/home')
    }
  }

  componentWillReceiveProps(np) {
    const { loginSuccess, history, signOut, fetchRooms, rooms } = np
    if (loginSuccess) {
      // shows modal on login error either for account does not exists or incorrect password
      if (loginSuccess.errors) {
        signOut()
        setTimeout(() => {
          this.setState({ showError: true })
        }, 300)
      } else if (!loginSuccess.errors) { // redirects to home on successfully logged in
        localStorage.setItem('temperatureType', 'F') // Local storage to identify Celsius and Fahrenheit setting by user
        const token = SecureStorage.encrypt(loginSuccess.data.getToken)
        localStorage.setItem(Config.LocalStorageKeys.Authorization, token)
        // call after validating login token
        fetchRooms()
        if (rooms) {
          if (rooms.length === 0) {
            history.push('/register-cozy')
          } else if (rooms.length > 0) {
            history.push('/home')
          }
        }
      }
    }
  }
  // API call to login
  onSubmit(data) {
    const { login } = this.props
    login(data)
  }
  // Will be called from child modal component
  closeModal(pagePreserve) {
    const { history } = this.props
    this.setState({ showError: false })
    // Redirect to signup when either there is no account or incorrect password
    if (!pagePreserve) {
      history.push('/signup')
    }
  }

  render() {
    const { handleSubmit } = this.props
    return (
      <div>
        <main id="login-page">
          <Detector
            render={({ online }) => (
              <div className={online ? '' : 'internet-offline'}>
                <Offline>You are offline at the moment!</Offline>
              </div>
            )}
          />
          <div className="wrapper">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 login-box-left">
                  <div className="login-box-left-inner">
                    <header className="header login-header display-flex d-block d-md-none">
                      <div className="text-center">
                        <div className="header-img-box">
                          <img src="/img/login-bg@3x.png" alt="" />
                        </div>
                        <div className="logo-container">
                          <div className="logo-container-inner">
                            <Link to="/home">
                              <img alt="" className="mobile-logo" src="img/white-logo.svg" />
                              <small>Operated by Radiator Labs</small>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </header>
                    <img alt="" className="d-none d-md-block" src="img/login_left_img.png" />
                  </div>
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12 login-box-right">
                  <div className="login-form">
                    <div className="header-img-box d-none d-md-block">
                      <Link to="/home">
                        <img src="/img/yellow-logo.png" alt="" />
                      </Link>
                      <div className="logo-title">Operated by Radiator Labs</div>
                    </div>
                    <form className="form" onSubmit={handleSubmit(this.onSubmit)}>
                      <div className="form-group">
                        <label>Email Address</label>
                        <div className="input-box">
                          <Field
                            name="email"
                            component={renderField}
                            type="email"
                            className="form-control email-icon"
                            placeholder="Enter email"
                            autoComplete="off"
                          />
                          <img className="img-fluid emailimg-icon" alt="" src="/img/email-icon.svg" />
                        </div>
                      </div>

                      <div className="form-group">
                        <label>Password</label>
                        <div className="input-box">
                          <Field
                            name="password"
                            component={renderField}
                            type="password"
                            className="form-control password-icon"
                            placeholder="Password"
                            autoComplete="none"
                          />
                          <img className="img-fluid password-icon emailimg-icon" alt="" src="/img/password-icon.svg" />
                        </div>
                      </div>

                      {/*<Link className="forgot-link link" to="/forgot-password">
                        Forgot Password?
                      </Link>*/}

                      <a className="forgot-link link" href="https://help.radiatorlabs.com">
                        Forgot Password?
                      </a>
                      <button type="submit" className="btn btn-primary btn-lg btn-block">
                        Login
                      </button>
                      <div className="login-signup-link">
                        <span>
                          Donʼt have an account?{' '}
                          <Link className="link" to="/signup">
                            Sign Up
                          </Link>
                        </span>
                        <span>
                          Need help?{' '}
                          <a className="link" rel="noopener noreferrer" href="https://radiatorlabs.zendesk.com/hc/en-us/requests/new" target="_blank">
                            Contact Us
                          </a>
                        </span>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ErrorModal modalType="loginError" open={this.state.showError} {...this.props} closeModal={this.closeModal} />
        </main>
      </div>
    )
  }
}

export default reduxForm({
  form: 'login', // a unique identifier for this form
  destroyOnUnmount: true,
  validate
})(Login)



// WEBPACK FOOTER //
// ./src/views/Login/component.js